import { LeftBanner } from 'moduleBase/types/Menu';
import React, { FC, useState } from 'react';
import arrowLeft from 'images/arrow-left.svg';
import arrowRight from 'images/arrow-right.svg';
import close from 'images/close-alt.svg';
import leftBanner from 'srcCss/modules/left-banners/left-banners.module.scss';
import { Carousel } from 'react-bootstrap';
import { useNetworkService } from 'hooks/use-network-service';
import { USER_SET_FLAG_URL } from '../../constants';

type PropsType = {
  banners: LeftBanner[],
};

const LeftBanners: FC<PropsType> = ({ banners }) => {
  const [index, setIndex] = useState<number>(0);
  const [elements, setElements] = useState<LeftBanner[]>(banners);
  const networkService = useNetworkService();

  if (!elements || !elements.length) {
    return null;
  }
  const setUserFlag = (key: string): Promise<void> => new Promise<void>((resolve) => {
    networkService.post<void>(USER_SET_FLAG_URL, {
      key,
    }).then(() => {
      resolve();
    });
  });

  const handleSelect = (selectedIndex: number) => {
    setIndex(selectedIndex);
  };

  const setPrev = () => {
    if ((index - 1) < 0) {
      setIndex(elements.length - 1);
      return;
    }
    setIndex(index - 1);
  };

  const setNext = () => {
    if ((index + 1) >= elements.length) {
      setIndex(0);
      return;
    }
    setIndex(index + 1);
  };

  const removeItem = () => {
    const filtered = elements.filter((el, idx) => idx !== index);
    setUserFlag(elements[index].key);
    if (!filtered[index]) {
      setIndex(index - 1);
    }
    setElements(filtered);
  };

  const renderCaption = () => (
    <div className={leftBanner.carouselHeader}>
      {(elements.length > 1)
        && (
        <>
          <button type="button" className={leftBanner.carouselControlPrev} onClick={setPrev}>
            <img src={arrowLeft} />
          </button>
          <button type="button" className={leftBanner.carouselControlNext} onClick={setNext}>
            <img src={arrowRight} />
          </button>
        </>
        )}
      <button type="button" className={leftBanner.carouselControlClose} onClick={removeItem}>
        <img src={close} />
      </button>
    </div>
  );

  return (
    <div className={leftBanner.desktopNavListCarousel}>
      {renderCaption()}
      <Carousel
        activeIndex={index}
        onSelect={handleSelect}
        controls={false}
        indicators={false}
        interval={null}
        slide={false}
      >
        {elements.map(({
          key, link, bannerUrl, banner2xUrl,
        }) => (
          <Carousel.Item key={key}>
            <a href={link} target="_blank" rel="noreferrer">
              <img
                className={leftBanner.carouselItemImg}
                src={bannerUrl}
                srcSet={banner2xUrl ? `${banner2xUrl} 2x` : ''}
              />
            </a>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

export { LeftBanners };
